import { callFunction } from './functionsClient';

export const getUserWords = (payload, getAccessToken) =>
  callFunction('getwords', payload, getAccessToken);
export const addWordToUser = (payload, getAccessToken) =>
  callFunction('addword', payload, getAccessToken);
